/*
kt
1: Päiväkoti, Koulu, Ravintola, Kirjasto
2: Myymälä
3: Pientalo, Rivitalo
4: Asuinkerrostalo
5: Toimisto
6: Hotelli
7: Palvelutalo
*/

const vaatimukset = [
  // P3
  { paloluokka: 'P3', kt: 1, sprinklaus: 'Ei', kerrosala: 2400, tilat: 400, korkeus: 9, kerrosmäärä: 1, henkilomäärä: 500, runko: '-' },
  { paloluokka: 'P3', kt: 1, sprinklaus: 'Vapaaehtoinen', kerrosala: 4800, tilat: 1200, korkeus: 9, kerrosmäärä: 1, henkilomäärä: 1000, runko: '-' },
  { paloluokka: 'P3', kt: 1, sprinklaus: 'Ei', kerrosala: 1600, tilat: 400, korkeus: 9, kerrosmäärä: 2, henkilomäärä: 50, runko: '-' },
  { paloluokka: 'P3', kt: 1, sprinklaus: 'Vapaaehtoinen', kerrosala: 2400, tilat: 600, korkeus: 9, kerrosmäärä: 2, henkilomäärä: 50, runko: '-' },
  { paloluokka: 'P3', kt: 2, sprinklaus: 'Ei', kerrosala: 2400, tilat: 400, korkeus: 9, kerrosmäärä: 1, henkilomäärä: 500, runko: '-' },
  { paloluokka: 'P3', kt: 2, sprinklaus: 'Vapaaehtoinen', kerrosala: 4800, tilat: 1200, korkeus: 9, kerrosmäärä: 1, henkilomäärä: 1000, runko: '-' },
  { paloluokka: 'P3', kt: 2, sprinklaus: 'Ei', kerrosala: 1600, tilat: 400, korkeus: 9, kerrosmäärä: 2, henkilomäärä: 50, runko: '-' },
  { paloluokka: 'P3', kt: 2, sprinklaus: 'Vapaaehtoinen', kerrosala: 2400, tilat: 600, korkeus: 9, kerrosmäärä: 2, henkilomäärä: 50, runko: '-' },
  { paloluokka: 'P3', kt: 3, sprinklaus: 'Ei', kerrosala: 2400, korkeus: 9, kerrosmäärä: 1, henkilomäärä: 250, runko: '-' },
  { paloluokka: 'P3', kt: 3, sprinklaus: 'Vapaaehtoinen', kerrosala: 4800, korkeus: 9, kerrosmäärä: 1, henkilomäärä: 500, runko: '-' },
  { paloluokka: 'P3', kt: 3, sprinklaus: 'Ei', kerrosala: 1600, korkeus: 9, kerrosmäärä: 2, henkilomäärä: 150, runko: '-' },
  { paloluokka: 'P3', kt: 3, sprinklaus: 'Vapaaehtoinen', kerrosala: 2400, korkeus: 9, kerrosmäärä: 2, henkilomäärä: 250, runko: '-' },
  { paloluokka: 'P3', kt: 4, error: 'Ei mahdollinen käyttötarkoituksen takia', kerrosmäärä: 1 },
  { paloluokka: 'P3', kt: 5, sprinklaus: 'Ei', kerrosala: 2400, tilat: 400, korkeus: 9, kerrosmäärä: 1, henkilomäärä: 250, runko: '-' },
  { paloluokka: 'P3', kt: 5, sprinklaus: 'Vapaaehtoinen', kerrosala: 4800, tilat: 1200, korkeus: 9, kerrosmäärä: 1, henkilomäärä: 500, runko: '-' },
  { paloluokka: 'P3', kt: 5, sprinklaus: 'Ei', kerrosala: 1600, tilat: 400, korkeus: 9, kerrosmäärä: 2, henkilomäärä: 150, runko: '-' },
  { paloluokka: 'P3', kt: 5, sprinklaus: 'Vapaaehtoinen', kerrosala: 2400, tilat: 600, korkeus: 9, kerrosmäärä: 2, henkilomäärä: 150, runko: '-' },
  { paloluokka: 'P3', kt: 6, sprinklaus: 'Ei', kerrosala: 2400, tilat: 400, yöpymistilat: 400, korkeus: 9, kerrosmäärä: 1, henkilomäärä: 50, runko: '-' },
  { paloluokka: 'P3', kt: 6, sprinklaus: 'Vapaaehtoinen', kerrosala: 4800, tilat: 1200, yöpymistilat: 600, korkeus: 9, kerrosmäärä: 1, henkilomäärä: 100, runko: '-' },
  { paloluokka: 'P3', kt: 6, sprinklaus: 'Ei', kerrosala: 1600, tilat: 400, yöpymistilat: 400, korkeus: 9, kerrosmäärä: 2, henkilomäärä: 10, runko: '-' },
  { paloluokka: 'P3', kt: 6, sprinklaus: 'Vapaaehtoinen', kerrosala: 2400, tilat: 1200, yöpymistilat: 600, korkeus: 9, kerrosmäärä: 2, henkilomäärä: 10, runko: '-' },
  { paloluokka: 'P3', kt: 7, sprinklaus: 'Ei', kerrosala: 2400, tilat: 400, yöpymistilat: 400, korkeus: 9, kerrosmäärä: 1, henkilomäärä: 10, runko: '-' },
  { paloluokka: 'P3', kt: 7, sprinklaus: 'Vapaaehtoinen', kerrosala: 2400, tilat: 1200, yöpymistilat: 600, korkeus: 9, kerrosmäärä: 1, henkilomäärä: 25, runko: '-' },
  // P2
  { paloluokka: 'P2', kt: 1, sprinklaus: 'Ei', tilat: 2400, korkeus: 9, kerrosmäärä: 1, runko: 'R 30' },
  { paloluokka: 'P2', kt: 1, sprinklaus: 'Vapaaehtoinen', tilat: 9600, korkeus: 9, kerrosmäärä: 1, runko: 'R 30' },
  { paloluokka: 'P2', kt: 1, sprinklaus: 'Ei', tilat: 2400, korkeus: 9, kerrosmäärä: 2, henkilomäärä: 250, runko: 'R 30' },
  { paloluokka: 'P2', kt: 1, sprinklaus: 'Vapaaehtoinen', tilat: 4800, korkeus: 9, kerrosmäärä: 2, henkilomäärä: 500, runko: 'R 30' },
  { paloluokka: 'P2', kt: 1, sprinklaus: 'Pakollinen', kerrosala: 12000, tilat: 1200, korkeus: 14, kerrosmäärä: 4, henkilomäärä: 1000, runko: 'R 60' },
  { paloluokka: 'P2', kt: 2, sprinklaus: 'Ei', tilat: 2400, korkeus: 9, kerrosmäärä: 1, runko: 'R 30' },
  { paloluokka: 'P2', kt: 2, sprinklaus: 'Vapaaehtoinen', tilat: 9600, korkeus: 9, kerrosmäärä: 1, runko: 'R 30' },
  { paloluokka: 'P2', kt: 2, sprinklaus: 'Ei', tilat: 2400, korkeus: 9, kerrosmäärä: 2, henkilomäärä: 250, runko: 'R 30' },
  { paloluokka: 'P2', kt: 2, sprinklaus: 'Vapaaehtoinen', tilat: 4800, korkeus: 9, kerrosmäärä: 2, henkilomäärä: 500, runko: 'R 30' },
  { paloluokka: 'P2', kt: 2, sprinklaus: 'Pakollinen', kerrosala: 12000, tilat: 300, korkeus: 14, kerrosmäärä: 4, henkilomäärä: 1000, runko: 'R 60' },
  { paloluokka: 'P2', kt: 3, sprinklaus: 'Ei', tilat: 'Huoneistoittain', korkeus: 9, kerrosmäärä: 2, runko: 'R 30' },
  { paloluokka: 'P2', kt: 3, sprinklaus: 'Ei', kerrosala: 12000, tilat: 'Huoneistoittain', korkeus: 14, kerrosmäärä: 4, henkilomäärä: 1000, runko: 'R 45' },
  { paloluokka: 'P2', kt: 3, sprinklaus: 'Vapaaehtoinen', kerrosala: 12000, tilat: 'Huoneistoittain', korkeus: 14, kerrosmäärä: 4, henkilomäärä: 1000, runko: 'R 30' },
  { paloluokka: 'P2', kt: 4, sprinklaus: 'Ei', tilat: 'Huoneistoittain', korkeus: 9, kerrosmäärä: 2, runko: 'R 30' },
  { paloluokka: 'P2', kt: 4, sprinklaus: 'Vapaaehtoinen', tilat: 'Huoneistoittain', korkeus: 9, kerrosmäärä: 2, runko: 'R 30' },
  { paloluokka: 'P2', kt: 4, sprinklaus: 'Pakollinen', kerrosala: 12000, tilat: 'Huoneistoittain', korkeus: 28, kerrosmäärä: 8, henkilomäärä: 1000, runko: 'R 60' },
  { paloluokka: 'P2', kt: 5, sprinklaus: 'Ei', tilat: 2400, korkeus: 9, kerrosmäärä: 2, runko: 'R 30' },
  { paloluokka: 'P2', kt: 5, sprinklaus: 'Vapaaehtoinen', tilat: 9600, korkeus: 9, kerrosmäärä: 1, runko: 'R 30' },
  { paloluokka: 'P2', kt: 5, sprinklaus: 'Vapaaehtoinen', tilat: 4800, korkeus: 9, kerrosmäärä: 2, runko: 'R 30' },
  { paloluokka: 'P2', kt: 5, sprinklaus: 'Pakollinen', kerrosala: 12000, tilat: 2400, korkeus: 28, kerrosmäärä: 8, henkilomäärä: 1000, runko: 'R 60' },
  { paloluokka: 'P2', kt: 6, sprinklaus: 'Ei', tilat: 1600, yöpymistilat: 800, korkeus: 9, kerrosmäärä: 1, henkilomäärä: 150, runko: 'R 30' },
  { paloluokka: 'P2', kt: 6, sprinklaus: 'Vapaaehtoinen', tilat: 2400, yöpymistilat: 1200, korkeus: 9, kerrosmäärä: 1, henkilomäärä: 300, runko: 'R 30' },
  { paloluokka: 'P2', kt: 6, sprinklaus: 'Ei', tilat: 1600, yöpymistilat: 800, korkeus: 9, kerrosmäärä: 2, henkilomäärä: 50, runko: 'R 30' },
  { paloluokka: 'P2', kt: 6, sprinklaus: 'Vapaaehtoinen', tilat: 2400, yöpymistilat: 1200, korkeus: 9, kerrosmäärä: 2, henkilomäärä: 100, runko: 'R 30' },
  { paloluokka: 'P2', kt: 6, sprinklaus: 'Pakollinen', kerrosala: 12000, tilat: 1200, yöpymistilat: 800, korkeus: 28, kerrosmäärä: 8, henkilomäärä: 500, runko: 'R 60' },
  { paloluokka: 'P2', kt: 7, sprinklaus: 'Ei', tilat: 1600, yöpymistilat: 800, korkeus: 9, kerrosmäärä: 1, henkilomäärä: 100, runko: 'R 30' },
  { paloluokka: 'P2', kt: 7, sprinklaus: 'Vapaaehtoinen', tilat: 2400, yöpymistilat: 1200, korkeus: 9, kerrosmäärä: 1, henkilomäärä: 200, runko: 'R 30' },
  { paloluokka: 'P2', kt: 7, sprinklaus: 'Ei', tilat: 1600, yöpymistilat: 800, korkeus: 9, kerrosmäärä: 2, henkilomäärä: 25, runko: 'R 30' },
  { paloluokka: 'P2', kt: 7, sprinklaus: 'Vapaaehtoinen', tilat: 2400, yöpymistilat: 1200, korkeus: 9, kerrosmäärä: 2, henkilomäärä: 50, runko: 'R 30' },
  { paloluokka: 'P2', kt: 7, sprinklaus: 'Pakollinen', kerrosala: 12000, tilat: 1200, yöpymistilat: 800, korkeus: 28, kerrosmäärä: 8, henkilomäärä: 150, runko: 'R 60' },
  // P1
  { paloluokka: 'P1', kt: 1, sprinklaus: 'Ei', tilat: 2400, kerrosmäärä: 1, runko: 'R 60' },
  { paloluokka: 'P1', kt: 1, sprinklaus: 'Vapaaehtoinen', tilat: 24000, kerrosmäärä: 1, runko: 'R 60' },
  { paloluokka: 'P1', kt: 1, sprinklaus: 'Ei', tilat: 2400, kerrosmäärä: 2, runko: 'R 60' },
  { paloluokka: 'P1', kt: 1, sprinklaus: 'Vapaaehtoinen', tilat: 12000, kerrosmäärä: 2, runko: 'R 60' },
  { paloluokka: 'P1', kt: 2, sprinklaus: 'Ei', tilat: 2400, kerrosmäärä: 1, runko: 'R 90' },
  { paloluokka: 'P1', kt: 2, sprinklaus: 'Vapaaehtoinen', tilat: 24000, kerrosmäärä: 1, runko: 'R 90' },
  { paloluokka: 'P1', kt: 2, sprinklaus: 'Ei', tilat: 2400, kerrosmäärä: 2, runko: 'R 90' },
  { paloluokka: 'P1', kt: 2, sprinklaus: 'Vapaaehtoinen', tilat: 12000, kerrosmäärä: 2, runko: 'R 90' },
  { paloluokka: 'P1', kt: 3, error: 'Toteutetaan tavallisesti P3- tai P2-paloluokassa' },
  { paloluokka: 'P1', kt: 4, sprinklaus: 'Ei', tilat: 2400, kerrosmäärä: 2, runko: 'R 60' },
  { paloluokka: 'P1', kt: 4, sprinklaus: 'Vapaaehtoinen', tilat: 2400, kerrosmäärä: 2, runko: 'R 60' },
  { paloluokka: 'P1', kt: 5, sprinklaus: 'Ei', tilat: 2400, kerrosmäärä: 1, runko: 'R 60' },
  { paloluokka: 'P1', kt: 5, sprinklaus: 'Vapaaehtoinen', tilat: 24000, kerrosmäärä: 1, runko: 'R 60' },
  { paloluokka: 'P1', kt: 5, sprinklaus: 'Ei', tilat: 2400, kerrosmäärä: 2, runko: 'R 60' },
  { paloluokka: 'P1', kt: 5, sprinklaus: 'Vapaaehtoinen', tilat: 12000, kerrosmäärä: 2, runko: 'R 60' },
  { paloluokka: 'P1', kt: 7, error: 'Ei mahdollinen palomääräysten takia' },
  { paloluokka: 'P1', kt: 7, error: 'Ei mahdollinen palomääräysten takia' }
]

function checkRequirements (candidate, fireClass) {
  var closest = null
  for (var index = 0; index < vaatimukset.length; ++index) {
    var test = vaatimukset[index]
    var result = { passed: false, error: '', runko: test.runko, mitoitus: candidate.mitoitus, kerrosmäärä: true, korkeus: false, kerrosala: false, henkilomäärä: false, paloosasto: false }
    var sprinklaus = candidate.sprinklaus === test.sprinklaus || (candidate.sprinklaus !== 'Ei' && test.sprinklaus !== 'Ei')

    if (fireClass === test.paloluokka) {
      if (test.error && candidate.kt === test.kt) {
        result.passed = false
        result.error = test.error
        return result
      }

      // Custom errors
      if (fireClass === 'P3') {
        if (candidate.korkeus > 9 || candidate.kerrosmäärä > 2 || (candidate.ktid === 10 && candidate.kerrosmäärä > 1)) {
          result.error = 'Ei mahdollinen kerrosmäärän tai korkeuden takia'
          return result
        }
      }

      if (fireClass === 'P2') {
        if (candidate.sprinklaus === 'Ei' && (candidate.korkeus > 9 || candidate.kerrosmäärä > 2) && candidate.kt !== 3) {
          result.error = 'Ei mahdollinen sprinklauksen puuttumisen takia'
          return result
        }
        if (candidate.kt < 4 && candidate.kerrosmäärä > 4) {
          result.error = 'Ei mahdollinen kerrosmäärän tai korkeuden takia'
          return result
        }
        if (candidate.kt > 3 && candidate.kerrosmäärä > 8) {
          result.error = 'Ei mahdollinen kerrosmäärän tai korkeuden takia'
          return result
        }
      }

      if (fireClass === 'P1') {
        if ((candidate.ktid === 3 && candidate.tilat > 300) || candidate.ktid === 4) {
          result.mitoitus = 'Taulukko<br/><small>600 - 1200 MJ/m<sup>2</sup></small>'
          if (candidate.sprinklaus !== 'Ei') {
            result.runko = 'R 60'
          } else {
            result.runko = 'R 90'
          }
        } else {
          result.mitoitus = 'Taulukko<br/><small>alle 600 MJ/m<sup>2</sup></small>'
          result.runko = 'R 60'
        }
        if (candidate.kt < 6 && candidate.kerrosmäärä > 2) {
          result.error = 'Ei mahdollinen kerrosmäärän takia'
          return result
        }
        if (candidate.ktid === 5 || candidate.ktid === 6) {
          result.error = 'Toteutetaan tavallisesti P3- tai P2-paloluokassa'
          return result
        }
        if (candidate.ktid === 9 || candidate.ktid === 10) {
          result.error = 'Ei mahdollinen puurunkoisena (kantavat rakenteet vähintään A2‐s1, d0‐luokkaa)'
          if (candidate.kerrosmäärä > 8) {
            result.error = 'Ei mahdollinen kerrosmäärän takia'
          }
          return result
        }
      }

      if (candidate.kt === test.kt && sprinklaus === true && candidate.kerrosmäärä <= test.kerrosmäärä) { //
        // result.kerrosmäärä = candidate.kerrosmäärä <= test.kerrosmäärä
        result.kerrosala = typeof (test.kerrosala) === 'undefined' || candidate.kerrosala <= test.kerrosala
        result.paloosasto = typeof (test.tilat) === 'undefined' || candidate.tilat <= test.tilat || test.tilat === 'Huoneistoittain'
        result.korkeus = typeof (test.korkeus) === 'undefined' || candidate.korkeus <= test.korkeus
        result.henkilomäärä = typeof (test.henkilomäärä) === 'undefined' || candidate.henkilomäärä <= test.henkilomäärä
        result.yöpymistilat = typeof (test.yöpymistilat) === 'undefined' || candidate.yöpymistilat <= test.yöpymistilat
        if (result.yöpymistilat === false) {
          result.paloosasto = false
        }
        result.passed = result.kerrosmäärä && result.kerrosala && result.paloosasto && result.korkeus && result.henkilomäärä

        if (result.passed) {
          return result
        } else if (countMatches(result) > countMatches(closest)) {
          closest = result
        }
      }

      // this is not perfect
      if (candidate.kt === test.kt && sprinklaus === true && candidate.kerrosmäärä > test.kerrosmäärä) {
        closest = result
        closest.kerrosmäärä = false
      }
    }
  }

  return closest // if nothing passed, we return the result with most points
}

function countMatches (resultObj) {
  var count = 0
  if (resultObj !== null) {
    if (resultObj.kerrosala) { count++ }
    if (resultObj.paloosasto) { count++ }
    if (resultObj.korkeus) { count++ }
    if (resultObj.kerrosmäärä) { count++ }
    if (resultObj.henkilomäärä) { count++ }
    if (resultObj.yöpymistilat) { count++ }
  }
  return count
}

/*
function checkSingleValue (valueName, value, fireClass) {
  for (var index = 0; index < vaatimukset.length; ++index) {
    var test = vaatimukset[index]
    if (test.paloluokka === fireClass) {
      if (value <= test[valueName]) {
        return true
      }
    }
  }
  return false
}
*/

export default checkRequirements



// WEBPACK FOOTER //
// ./src/data/vaatimukset.js